import React from 'react';
import { CLIENT_STORIES } from '../mock';
import { TrendingUp } from 'lucide-react';

const avatarColors = [
  'from-blue-500 to-purple-500',
  'from-pink-500 to-rose-500',
  'from-amber-500 to-orange-500',
  'from-emerald-500 to-teal-500',
  'from-sky-500 to-indigo-500',
  'from-fuchsia-500 to-pink-500',
  'from-violet-500 to-blue-500',
];

const ClientStories = () => (
  <section id="about" className="py-24">
    <div className="max-w-6xl mx-auto px-5 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-14">
        <p className="text-sm font-bold tracking-widest uppercase plixy-gradient-text">Client Success Stories</p>
        <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a1930]">Real people. Real growth. Real followers.</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CLIENT_STORIES.slice(0, 8).map((c, i) => (
          <div key={c.handle} className="group p-5 rounded-2xl bg-white border border-slate-200 hover:-translate-y-1 hover:shadow-xl transition-all">
            <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{c.category}</div>
            <div className="mt-3 flex items-center gap-3">
              <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${avatarColors[i % avatarColors.length]} text-white flex items-center justify-center font-bold text-sm`}>
                {c.name.split(' ').map(w => w[0]).join('').slice(0,2)}
              </div>
              <div>
                <div className="font-extrabold text-[#0a1930]">{c.name}</div>
                <div className="text-xs text-slate-500">{c.handle}</div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-2 gap-2 text-sm">
              <div>
                <div className="text-xs text-slate-500">Followers</div>
                <div className="font-bold text-[#0a1930]">{c.followers}</div>
              </div>
              <div>
                <div className="text-xs text-slate-500">Growth</div>
                <div className="font-bold text-emerald-600 inline-flex items-center gap-1"><TrendingUp className="w-3.5 h-3.5" /> {c.growth}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ClientStories;
